export const ITEMS_TO_FIND = [
  'DEER',
  'HOLIDAY CARD',
  'HUSKEY DOG',
  'WREATH',
  'GREEN ORNAMENT',
  'ANGEL',
  'ICE SKATES',
  'SANTA HAT',
  'STOCKING',
  'HOT CHOCOLATE',
  'NUTCRACKER',
  'WHITE BIRD',
  'CANDY CANE',
  'GREEN BOW',
  'POLAR BEAR',
  'MITTENS',
  'RUBBER DUCK',
  'UGLY SWEATER',
  'RACOON'
];

export const GAME_TIME = 120; // seconds
